import React from 'react';
import InputUser from '../InputUser';
import { HiringModeStyle, WrapperHiringMode } from './style';

export default function HiringMode({
  setHiringMode,
  hiringMode,
  setCPF,
  CPF,
  setNameCompany,
  nameCompany,
  setCNPJ,
  CNPJ,
}) {
  const ModeCLT = () => {
    setHiringMode('CLT');
    setCNPJ('');
    setNameCompany('');
  };

  const ModePJ = () => {
    setHiringMode('PJ');
    setCPF('');
  };

  return (
    <HiringModeStyle>
      <WrapperHiringMode>
        <p>Modo de contratação</p>
        <button id={hiringMode === 'CLT' ? 'active' : ''} onClick={ModeCLT}>
          CLT
        </button>
        <button id={hiringMode === 'PJ' ? 'active' : ''} onClick={ModePJ}>
          PJ
        </button>
      </WrapperHiringMode>
      {hiringMode === 'CLT' ? (
        <InputUser
          label="CPF"
          type="text"
          onChange={(e) => setCPF(e.target.value)}
          value={CPF}
          placeholder="Digite o CPF do usuário."
        />
      ) : hiringMode === 'PJ' ? (
        <div>
          <InputUser
            label="Nome da Empresa"
            type="text"
            onChange={(e) => setNameCompany(e.target.value)}
            value={nameCompany}
            placeholder="Nome fantasia ou jurídico"
          />
          <InputUser
            label="CNPJ"
            type="text"
            onChange={(e) => setCNPJ(e.target.value)}
            value={CNPJ}
            placeholder="Digite o CNPJ da empresa."
          />
        </div>
      ) : (
        <div></div>
      )}
    </HiringModeStyle>
  );
}
